export default __webpack_public_path__ + "static/media/Img_energy_storage.fb35e7fd.svg";